// Domain
import { StepDto } from '@/modules/onboarding/status/domain/dtos';
import { SectionBase } from '@/modules/onboarding/status/domain/services/onboarding-step/step';

export default class HiringProcessCompleted implements SectionBase {
  getStepAndSubStep(): StepDto {
    return {
      step: 9,
      substep: 1,
    };
  }
}
